import type { TranslationInterface } from '.';

export const ItalianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Scrivi un messaggio...',
  your_issue_has_been_resolved: 'Il tuo problema è stato risolto!',
  new_conversation: 'Nuova conversazione',
  welcome_screen_title: 'Benvenuto nella nostra chat di supporto',
  welcome_screen_description:
    'Siamo qui per aiutarti! Inizia una conversazione e ti risponderemo il prima possibile.',
  your_name_placeholder: 'Il tuo nome',
  your_email_placeholder: 'Il tuo indirizzo email',
  start_chat_button: 'Parla con il supporto',
  start_chat_button_loading: 'Connessione in corso...',
  i_need_more_help: 'Ho bisogno di ulteriore aiuto',
  this_was_helpful: 'Questo è stato utile',
  optional: 'Opzionale',
  no_conversations_yet: 'Nessuna conversazione ancora',
  back_to_conversations: 'Torna alle conversazioni',
  closed_conversations: 'Conversazioni chiuse',
  csat_title: 'Com’è andata la tua conversazione?',
  csat_submitted_title: 'Hai valutato la conversazione come',
  csat_feedback_placeholder: 'Dicci di più... (facoltativo)',
  follow_up_placeholder: 'Continua…',
  companion_layout_label: 'Layout',
  companion_layout_floating: 'Mobile',
  companion_layout_sidebar: 'Barra laterale',
  companion_layout_fullscreen: 'Schermo intero',
  companion_close: 'Chiudi',
  companion_history: 'Cronologia conversazioni',
  companion_expand_chat: 'Espandi chat',
  companion_sidebar_dock_label: 'Aggancio',
  companion_sidebar_side_label: 'Lato',
  companion_sidebar_left: 'Sinistra',
  companion_sidebar_right: 'Destra',
  companion_resize_chat: 'Ridimensiona chat',
  scroll_to_bottom: 'Scorri fino in fondo',
  thinking: 'Sto pensando…',
  running: 'In esecuzione…',
  steps: 'passaggi',
  step_arguments: 'Argomenti',
  step_result: 'Risultato',
  attach_files:
    'Allega immagini, video, PDF o fogli di calcolo (dimensione massima 25 MB)',
  mark_page_active:
    'Fai clic su un elemento della pagina per contrassegnarlo — Esc per annullare',
  mark_page:
    'Contrassegna un elemento della pagina per fare una domanda al riguardo',
  stop_response: 'Interrompi risposta',
  copy_reply: 'Copia risposta',
  mentions_empty: 'Nessun risultato',
  copied: 'Copiato',
  send_message: 'Invia messaggio',
  upload_failed: 'Caricamento non riuscito: {error}',
  remove_attachment: 'Rimuovi allegato',
  json_no_items: 'Nessun elemento',
  json_no_data: 'Nessun dato',
  json_no_chart_data: 'Nessun dato per il grafico',
  json_unsupported: 'Non supportato: {type}',
  json_see_less: 'Mostra meno',
  json_phone_agent: 'Agente telefonico',
  json_phone_agent_test: 'Prova via web',
  page_context_remove: 'Rimuovi il contesto della pagina',
  json_see_more: 'Mostra altri {count}',
  queued_label: '{count} In coda',
  remove_queued_message: 'Rimuovi messaggio dalla coda',
  send_queued_now: 'Invia ora i messaggi in coda',
  turn_failed_message:
    'Si è verificato un problema e la risposta non è arrivata.',
  turn_failed_retry: 'Riprova',
  page_mark_hint: 'Fai clic su un elemento per contrassegnarlo',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Riquadro',
  page_mark_shape_circle: 'Cerchio',
  page_mark_shape_arrow: 'Freccia',
  page_mark_shape_bracket: 'Parentesi',
  page_mark_shape_underline: 'Sottolineatura',
  page_mark_shape_highlight: 'Evidenziazione',
  page_mark_shape_strike_through: 'Barrato',
  page_mark_shape_crossed_off: 'Cancellato con una croce',
  page_mark_shape_aria: 'Forma del segno: {shape}',
  page_mark_note_placeholder: 'Aggiungi una nota… (Invio per allegare)',
  page_mark_attach: 'Allega segno',
  page_mark_remove: 'Rimuovi {label}',
  page_mark_region: 'Area contrassegnata',
  page_mark_default_message: 'Che cos’è questo?',
  file_rejected: 'Il tipo di file non è supportato o il file è troppo grande.',
  dictate: 'Detta',
  stop_dictation: 'Interrompi dettatura',
  dictation_mic_blocked: "Consenti l'accesso al microfono per dettare",
  dictation_unavailable: 'La dettatura non è disponibile al momento',
  questions_back: 'Indietro',
  questions_next: 'Avanti',
  questions_send: 'Invia',
  questions_type_answer: 'Lo scrivo io',
  questions_answer_placeholder: 'Scrivi la tua risposta…',
  close_conversation_title: 'Chiudi conversazione',
  close_conversation_description: 'Vuoi davvero chiudere questa conversazione?',
  close_conversation_cancel: 'No',
  close_conversation_confirm: 'Sì',
  dialog_close: 'Chiudi',
  zoom_in: 'Ingrandisci',
  zoom_out: 'Riduci',
  reset_zoom: 'Reimposta zoom',
  support_chat_aria_label: 'Chat di supporto',
};
